module.exports = __webpack_public_path__ + "08b9bb4fe1a095197edcdcd6162246aa.svg";